import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import CustomTable from "../../Components/CustomTable";
import { useDispatch } from "react-redux";
// import { resultList } from "../../Redux/Slices/resultSlice";
import { getVillageList, getEducationList, getOccupationList, userAnalyticsList, userApproveReject, userReject } from "../../Redux/Slices/userAnalyticsSlice";
import toast from "react-hot-toast";


const UserNotification = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [paginationState, setPaginationState] = useState({
        page: 1,
        limit: 10,
    });
    const [paginationData, setPaginationData] = useState([]);
    const [SelectedVillage, setSelectedVillage] = useState(null);
    const [SelectedEducation, setSelectedEducation] = useState(null);
    const [SelectedOccupation, setSelectedOccupation] = useState(null);
    const [villages, setVillages] = useState([]);
    const [educations, setEducations] = useState([]);
    const [occupations, setOccupations] = useState([]);
    const [villageSearch, setVillageSearch] = useState("");
    const [educationSearch, setEducationSearch] = useState("");
    const [isVillageLoading, setIsVillageLoading] = useState(false);

    const menuPortalStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    const getVillage = async (search = "") => {
        setIsVillageLoading(true);
        try {
            const payload = { search };
            const response = await dispatch(getVillageList(payload)).unwrap();
            if (response.IsSuccess) {
                setVillages(response.Data || []);
            }
        } catch (error) {
            toast.error("Failed to fetch Villages");
        } finally {
            setIsVillageLoading(false);
        }
    };
    const getEducation = async (search = "") => {
        try {
            const response = await dispatch(getEducationList({ search })).unwrap();
            if (response.IsSuccess) {
                setEducations(response.Data || []);
            }
        } catch (error) {
            toast.error("Failed to fetch Education");
        }
    };
    const getOccupation = async () => {
        try {
            const response = await dispatch(getOccupationList()).unwrap();
            if (response.IsSuccess) {
                setOccupations(response.Data || []);
            }
        } catch (error) {
            toast.error("Failed to fetch Business");
        }
    };

    const getUserListFun = async () => {
        try {
            setLoading(true);
            const payload = {
                page: paginationState.page,
                limit: paginationState.limit,
                search: searchValue || "",
                village: SelectedVillage || "",
                education: SelectedEducation || "",
                business: SelectedOccupation || "",
                status: "",
                is_approved: false,
            };
            const response = await dispatch(userAnalyticsList(payload)).unwrap();
            setTableData(response.Data.docs);
            setPaginationData(response.Data.totalDocs);
        } catch (error) {
            console.log("error :>> ", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = async (page, limit) => {
        setLoading(true);
        try {
            const payload = {
                page: page || 1,
                limit: limit || 10,
                search: searchValue || "",
                village: SelectedVillage || "",
                education: SelectedEducation || "",
                business: SelectedOccupation || "",
                status: "",
                is_approved: false,
            };
            setPaginationState({ page: page, limit: limit });
            const response = await dispatch(userAnalyticsList(payload)).unwrap();
            setTableData(response.Data.docs);
            setPaginationData(response.Data.totalDocs);
            setLoading(false);
        } catch (error) {
            console.log("error :>> ", error);
        }
    };

    const handleClearFilter = () => {
        setSelectedEducation("");
        setSelectedVillage("");
        setSearchValue("");
        setVillageSearch("");
        setEducationSearch("");
    }

    const columns = [
        {
            key: "name",
            label: "User Name",
            renderCell: (key, row) => (
                <div onClick={() => handleEditNotification(row)}>
                    <span className="hover:text-primary hover:font-semibold cursor-pointer">{row?.name + " " + row?.surname}</span>
                </div>
            )
        },
        {
            key: "village",
            label: "Village",
            renderCell: (key, row) => row.village?.gujarati_name || '-'
        },
        {
            key: "is_approved",
            label: "Mobile Number Status",
            renderCell: (key, row) => (
                <span
                    className={`px-3 py-1.5 rounded-md shadow-custom_shadow ${row?.is_mobileverified
                        ? 'text-green bg-[#E7FAF0]'  // Verified
                        : 'text-red bg-light_red'  // Unverified
                        }`}
                >
                    {row?.is_mobileverified ? "Verified" : "Unverified"}
                </span>
            )
        },
        {
            key: "action",
            label: "Action",
            renderCell: (key, row) => (
                <div className="flex items-center justify-center gap-2">
                    <button className="flex items-center cursor-pointer space-x-2.5" onClick={() => acceptRequest(row?._id)}>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#048746" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.4134 10.6025C20.9084 11.015 20.9753 11.7506 20.5628 12.2456L14.9339 19.0003C14.3849 19.659 13.3888 19.7042 12.7824 19.0978L9.50821 15.8237C9.0526 15.3681 9.0526 14.6294 9.50821 14.1738C9.96382 13.7182 10.7025 13.7182 11.1581 14.1738L13.7548 16.7704L18.7702 10.7518C19.1827 10.2569 19.9184 10.19 20.4134 10.6025Z" fill="white" />
                        </svg>
                    </button>

                    <button className="flex items-center cursor-pointer space-x-2.5" onClick={() => rejectRequest(row?._id)}>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#D21A0E" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M10.0917 10.0917C10.5473 9.6361 11.286 9.6361 11.7416 10.0917L19.9083 18.2584C20.3639 18.714 20.3639 19.4527 19.9083 19.9083C19.4527 20.3639 18.714 20.3639 18.2584 19.9083L10.0917 11.7416C9.6361 11.286 9.6361 10.5473 10.0917 10.0917Z" fill="white" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M19.9083 10.0917C20.3639 10.5473 20.3639 11.286 19.9083 11.7416L11.7416 19.9083C11.286 20.3639 10.5473 20.3639 10.0917 19.9083C9.6361 19.4527 9.6361 18.714 10.0917 18.2584L18.2584 10.0917C18.714 9.6361 19.4527 9.6361 19.9083 10.0917Z" fill="white" />
                        </svg>
                    </button>
                </div>
            ),
        },
    ];

    const acceptRequest = async (userid) => {
        try {
            setLoading(true);
            await dispatch(userApproveReject({
                userId: userid || ""
            })).unwrap();
            // await getUserListFun();
            setLoading(false);
            navigate('/users-analytics');
        } catch (error) {
            setLoading(false);
            console.log("error :>> ", error);
        }
    }

    const rejectRequest = async (userid) => {
        try {
            setLoading(true);
            await dispatch(userReject({
                userId: userid || "",
            })).unwrap();
            await getUserListFun();
            setLoading(false);
            toast.success("User Remove Successfully");
            // navigate(-1);
        } catch (error) {
            setLoading(false);
            console.log("error :>> ", error);
        }
    }

    const handleEditNotification = (row) => {
        // event.preventDefault();
        navigate(`edit-notification/${row._id}`);
    }

    useEffect(() => {
        getVillage(villageSearch);
    }, [villageSearch]);

    useEffect(() => {
        const timer = setTimeout(() => getEducation(educationSearch), 500);
        return () => clearTimeout(timer);
    }, [educationSearch]);

    useEffect(() => {
        // getVillage();
        getOccupation();
    }, []);

    useEffect(() => {
        setTableData([]);
        getUserListFun();
    }, [SelectedEducation, SelectedVillage, SelectedOccupation, searchValue]);

    // const handleEditNotification = (event) => {
    //     event.preventDefault();
    //     navigate('../users-notification/edit-notification');
    // }

    return (
        <>
            <div className="p-5 md:p-6 lg:p-7 2xl:p-9 h-[calc(100vh-61px)] md:h-[calc(100vh-77px)] lg:h-[calc(100vh-81px)] 2xl:h-[calc(100vh-89px)]">
                <div className="flex flex-col">
                    {/* Filter Section */}
                    <div className="flex flex-wrap gap-4 mb-6">
                        <div className="flex items-center gap-4 ml-auto">
                            <div className="relative">
                                <input
                                    onKeyUpCapture={(e) => setSearchValue(e.target.value)}
                                    type="search"
                                    placeholder="Search"
                                    className="pl-10 pr-4 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                                />
                                <span className="absolute left-3 top-2.5">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.125 1C4.63769 1 1 4.63769 1 9.125C1 13.6123 4.63769 17.25 9.125 17.25C13.6123 17.25 17.25 13.6123 17.25 9.125C17.25 4.63769 13.6123 1 9.125 1ZM2.25 9.125C2.25 5.32804 5.32804 2.25 9.125 2.25C12.922 2.25 16 5.32804 16 9.125C16 12.922 12.922 16 9.125 16C5.32804 16 2.25 12.922 2.25 9.125Z" fill="#8897AE" />
                                        <path d="M16.2337 15.3498C15.9896 15.1057 15.5939 15.1057 15.3498 15.3498C15.1057 15.5939 15.1057 15.9896 15.3498 16.2337L18.683 19.567C18.9271 19.8111 19.3228 19.8111 19.5669 19.567C19.811 19.3229 19.811 18.9272 19.5669 18.6831L16.2337 15.3498Z" fill="#8897AE" />
                                    </svg>
                                </span>
                            </div>
                            <Select
                                id="village"
                                name="village"
                                isLoading={isVillageLoading}
                                filterOption={() => true}
                                inputValue={villageSearch}
                                onInputChange={(inputValue, { action }) => {
                                    if (action === "input-change") setVillageSearch(inputValue);
                                }}
                                onBlur={() => setVillageSearch("")}
                                options={villages.map((item) => ({
                                    value: item?._id,
                                    label: item?.gujarati_name,
                                }))}
                                value={
                                    villages
                                        .filter((v) => v._id === SelectedVillage)
                                        .map((item) => ({
                                            value: item?._id,
                                            label: item?.gujarati_name,
                                        }))[0] || null
                                }
                                onChange={(selectedOption) => {
                                    setVillageSearch("");
                                    setSelectedVillage(selectedOption ? selectedOption.value : "");
                                }}
                                placeholder="સભ્યના ગામનું નામ"
                                classNamePrefix="react-select"
                                className="min-w-[220px]"
                                menuPortalTarget={document.body}
                                styles={menuPortalStyles}
                            />
                            <Select
                                id="education"
                                name="education"
                                filterOption={() => true}
                                inputValue={educationSearch}
                                onInputChange={(inputValue, { action }) => {
                                    if (action === "input-change") setEducationSearch(inputValue);
                                }}
                                onBlur={() => setEducationSearch("")}
                                options={educations.map((item) => ({
                                    value: item?._id,
                                    label: item?.gujarati_name,
                                }))}
                                value={
                                    educations
                                        .filter((e) => e._id === SelectedEducation)
                                        .map((item) => ({
                                            value: item?._id,
                                            label: item?.gujarati_name,
                                        }))[0] || null
                                }
                                onChange={(selected) => {
                                    setEducationSearch("");
                                    setSelectedEducation(selected ? selected.value : "");
                                }}
                                placeholder="સભ્યનું એજ્યુકેશન"
                                classNamePrefix="react-select"
                                className="min-w-[220px]"
                                menuPortalTarget={document.body}
                                styles={menuPortalStyles}
                                isClearable
                            />
                            <button className="btn flex justify-center items-center space-x-1" onClick={() => handleClearFilter()}>
                                <span className="icon-plus text-[20px] font-extrabold"></span>
                                <span>Clear Filter</span>
                            </button>
                        </div>
                    </div>

                    {/* Table Section */}
                    <CustomTable
                        columns={columns}
                        data={tableData}
                        isPagination={true}
                        totalRecords={paginationData}
                        loading={loading}
                        handlePageChange={handlePageChange}
                        currentPage={paginationState.page}
                        pageSize={paginationState.limit}
                    />
                </div>
            </div>
        </>
    );
}

export default UserNotification;
